export const guideSteps = [
  {
    id: "step-1",
    step: "01",
    icon: "ri-compass-3-line",
    title: "先看合集导读",
    desc:
      "从导读了解潘金莲这一题材的来源与整体范围，明确它横跨电影、电视剧、系列影片与舞台等多个方向，再决定深入哪一块。",
  },
  {
    id: "step-2",
    step: "02",
    icon: "ri-layout-grid-line",
    title: "按内容构成定位",
    desc:
      "在“合集内容构成”中先选出你最感兴趣的方向，例如古装电影或长篇电视剧，可以避免在庞杂条目中迷失重点。",
  },
  {
    id: "step-3",
    step: "03",
    icon: "ri-filter-3-line",
    title: "用标签筛选推荐",
    desc:
      "进入“电影推荐”后，点击古装电影、文艺改编、系列影片等标签，页面只会保留符合条件的条目，方便对比与挑选。",
  },
  {
    id: "step-4",
    step: "04",
    icon: "ri-time-line",
    title: "沿年代线对照",
    desc:
      "在“改编电影大全”的时间线上按年代顺序浏览，能直观看到同一题材在不同阶段的处理差异与演变脉络。",
  },
];

export const navItems = [
  { id: "overview", label: "合集导读" },
  { id: "collections", label: "内容构成" },
  { id: "adaptations", label: "题材影视剧" },
  { id: "series", label: "系列电影" },
  { id: "timeline", label: "改编大全" },
  { id: "recommend", label: "电影推荐" },
  { id: "faq", label: "常见问题" },
];